<template>
    <div class="language-list mt-32 flex flex-row items-center justify-center h-6 text-text text-xl">
        <div v-for="(language, id) in languages"
             @click="setLanguage(language)"
             class="text-center cursor-pointer px-10 border-text"
             :class="{ 'border-l': !!id, 'text-heading': language === currentLanguage() }"
        >
            {{ language.toUpperCase() }}
        </div>
    </div>
</template>

<script>
import {Translatable} from '@/data/translations';

export default {
    name: 'LanguageList',
    mixins: [Translatable],
    methods: {
        setLanguage(language) {
            this.$emit('set-language', language);
        },
    },
};
</script>

<style scoped>
    .language-list {
        transform: translateX(20px);
        transition: all 0.2s ease-in-out;
        opacity: 0;
    }
</style>
